import { Alert, Grid, Layout as LayoutAntd } from "antd";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router";
import { Header } from "./components/Header";
import { PageLoader } from "./components/PageLoader";
import { Sidebar } from "./components/Sidebar";
import { CACHE_VERSION } from "./constants/CACHE_VERSION";
import { useNetworkStatus } from "./hooks/useNetworkStatus";
import { usePermissao } from "./hooks/usePermissao";
import { useSyncData } from "./hooks/useSyncData";

export function Layout({ children }: { children: React.ReactNode }) {
  const screens = Grid.useBreakpoint();
  const { pathname } = useLocation();
  const { isOnline } = useNetworkStatus();
  const { user, isLoading } = useAuth();
  const { hasEnabledRoute } = usePermissao();
  const [collapsed, setCollapsed] = useState(false);

  useSyncData();

  if (isLoading) {
    return <PageLoader />;
  }

  const validateUser = !!user;

  if (!validateUser) {
    return <Navigate to="/login" replace />;
  }

  if (!hasEnabledRoute(pathname)) {
    return <Navigate to="/inicio" replace />;
  }

  return (
    <LayoutAntd hasSider>
      {(screens.lg || screens.md) && <Sidebar collapsed={collapsed} />}

      <LayoutAntd style={{ minHeight: "100vh" }}>
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />
        {!isOnline && (
          <Alert
            message="Sem acesso a internet"
            type="error"
            style={{ textAlign: "center", fontWeight: "bold" }}
          />
        )}

        {navigator.language !== "pt-BR" && (
          <Alert
            message="Idioma não suportado"
            description="Selecione o idioma português nas configurações do navegador"
            type="warning"
            style={{ textAlign: "center" }}
          />
        )}

        <LayoutAntd.Content
          style={{
            margin: "24px 16px 0",
            overflow: "initial",
            padding: 24,
            backgroundColor: "#fff",
            minHeight: 280,
          }}
        >
          {children}
        </LayoutAntd.Content>
        <LayoutAntd.Footer style={{ textAlign: "center" }}>
          {CACHE_VERSION}
        </LayoutAntd.Footer>
      </LayoutAntd>
    </LayoutAntd>
  );
}
